// extracted by mini-css-extract-plugin
export default {"inputBox":"iconInput_inputBox__YIzrx"};